import { render } from "./PrintInvoiceMoneyDetailsDesign2.vue?vue&type=template&id=573aa264"
import script from "./PrintInvoiceMoneyDetailsDesign2.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign2.vue?vue&type=script&lang=js"

import "./PrintInvoiceMoneyDetailsDesign2.vue?vue&type=style&index=0&id=573aa264&scoop=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__